// Components
const ModalModifyTreatment = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-modify-treament" */ '@/app/views/main-view/_shared/_components/treatment-component/modals/modal-modify-treatment/modal-modify-treatment.vue');
const ModalAddTreatment = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-add-treatment" */ '@/app/views/main-view/_shared/_components/treatment-component/modals/modal-add-treatment/modal-add-treatment.vue');

// Mixins
import { GoogleAnalyticsMixins } from '@/app/mixins/utils/google-analytics-mixins';
import { userMixins } from '@/app/mixins/modules/user-mixins.js';
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { switchPetMixins } from '@/app/mixins/modules/switch-pet-mixins';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

// Constants
import { GA } from '@/app/constants/ga-constants';
import { STATUS_CODES, SUCCESS_MSG } from '@/app/constants/status-constants';


// Services
import treatmentService from '@/app/services/main/treatment/treatment-service.js';

// Third party libraries
import { format, parseISO } from 'date-fns';
import EventBus from '@/app/bus/event-bus';

export default {
	name: 'TreatmentComponent',
	components:{
		ModalModifyTreatment,
		ModalAddTreatment
	},
	mixins: [
		GoogleAnalyticsMixins,
		toastMessageMixins,
		userMixins,
		tableMixins,
		switchPetMixins
	],
	props: {
		isDashboard: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			// loaders
			isAPILoading: false,
			isAddModalLoading: false,
			// table
			theads: [
				{ name: null, sortLabel: null, isDesc: false, style: 'width: 10%;'},
				{ name: 'Type of treatment', sortLabel: null, isDesc: false, style: 'width: 45%;'},
				{ name: 'Date', sortLabel: 'date', isDesc: true, style: 'width: 45%;'}
			],
			// sorting
			desc: true,
			// modal
			modalContent: null,
		}
	},
	computed: {
        treatmentScheduleData() {
            return this.$store.getters.getTreatmentSchedule;
        },
		treatmentAPIError() {
			return this.$store.getters.getTreatmentAPIError;
		}
    },
	watch: {
		treatmentScheduleData(newTreatment) {
			if (newTreatment && !this.isDashboard) {
				this.showApplyTreatmentModal(newTreatment);
			}
		},
		treatmentAPIError(newVal) {
			if (newVal) {
				this.showAPIErrorToast(newVal.message, newVal.res);
			}
		}
	},
	created() {
		this.getTableContent();
	},
	mounted() {
		if (this.treatmentScheduleData && !this.isDashboard) {
			this.showApplyTreatmentModal(this.treatmentScheduleData);
		}
	},
	methods: {
		refreshActivePetData() {
			this.getTableContent();
		},
		showAddTreatmentModal() {
			this.$refs.modalAddTreatment.show();
		},
		showTreatmentPage() {
			this.$router.push('/treatment');
		},
		showApplyTreatmentModal(treatment) {
			const { applied, deleted } = treatment;

			if (applied || deleted) {
				const action = applied ? 'applied' : 'deleted';
				this.showCustomErrorToast(`Treatment is already ${action}.`, null, true);
			} else {
				this.modalContent = treatment;
				setTimeout(() => {
					this.$refs.modalApplyTreatment.show();
				}, 100); // wait for modal content to be rendered completely to avoid flicker
			}

			this.$store.commit('clearTreatmentScheduleData');
		},
		applyTreatment(date) {
			this.$swal({
				imageHeight: '30px',
				imageUrl: `${require('@/assets/images/_shared/success-dog.png')}`,
				imageAlt: 'Success Dog',
				title: 'Applied Treatment!',
				text: `You will be reminded to apply your next treatment on ${date}.`,
				confirmButtonText: 'Got it',
			})
				.then(() => {
                    this.refreshTableContent();
                    this.refreshSidebarAndNotif();
				});
			this.sendEventTrackingToGA(GA.TREATMENT_PAGE.APPLY_TREATMENT_MODAL.ACTION, GA.TREATMENT_PAGE.CATEGORY, GA.TREATMENT_PAGE.APPLY_TREATMENT_MODAL.LABEL);
		},
		getTableContent(page = this.page, limit = this.isDashboard ? 5 : this.limit, sortBy = this.sortBy, desc = this.desc) {
			this.getTreatmentList({ page, limit, sortBy, desc });
		},
        getTreatmentList(queryParams) {
			this.isAPILoading = true;

            treatmentService.getTreatments(this.getActivePet.id, queryParams)
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination
						};
                        this.isAPILoading = false;
                    } else if (res.status !== STATUS_CODES.UNAUTHORIZED) {
						this.isAPILoading = false;
						const { ERROR_GET_TREATMENT_LIST } = this.toastMessages.treatment();
						this.showAPIErrorToast(ERROR_GET_TREATMENT_LIST, res);
                    }
                });
        },
		refreshTableContent() {
			this.getTableContent(this.page, this.limit, null, true);
		},
		addTreatment(newTreatmentDetails) {
			const { selectedBundleId, treatmentDate } = newTreatmentDetails;
			const treatmentDetails = {
				bundleId: selectedBundleId,
				originalApplicationSchedule: treatmentDate
			}

			this.isAddModalLoading = true;
			treatmentService.postTreatments(this.getActivePet.id, treatmentDetails)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.isAddModalLoading = false;
						this.refreshTableContent();
						this.$swal({
							imageHeight: '30px',
							imageUrl: `${require('@/assets/images/general-info/dog-health.png')}`,
							imageAlt: 'Dog Health',
							title: 'Success!',
							text: `You will be reminded to apply your next treatment on ${format(parseISO(res.data.nextTreatmentScheduleDate), 'dd-MMM-yyyy')}.`,
							confirmButtonColor: '#4B8BFF',
							confirmButtonText: 'Add More',
							showCancelButton: true,
							cancelButtonColor: '#d33',
							cancelButtonText: 'Got it',
							width: '37rem',
							reverseButtons: true
						})
							.then(result => {
								if (result.value) {
									this.showAddTreatmentModal();
								}
                            });
                        this.refreshSidebarAndNotif();
						this.sendEventTrackingToGA(GA.TREATMENT_PAGE.ADD_TREATMENT_MODAL.ACTION, GA.TREATMENT_PAGE.CATEGORY, GA.TREATMENT_PAGE.ADD_TREATMENT_MODAL.LABEL);
					} else {
						const { ERROR_ADD_TREATMENT } = this.toastMessages.treatment();
						this.showAPIErrorToast(ERROR_ADD_TREATMENT, res);
					}
                })
        },
		deleteTreatment(treatment) {
			this.$swal({
				imageHeight: '30px',
				imageUrl: `${require('@/assets/images/_shared/dog-confirm.png')}`,
				imageAlt: 'Sad Dog',
				title: 'Delete Treatment',
				text: `Are you sure you want to delete ${treatment.product.name}?`,
				confirmButtonText: 'Confirm',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				reverseButtons: true
			})
			.then(result => {
				if (result.value) {
					treatmentService.deleteTreatment(treatment.treatment.id)
						.then(res => {
							if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
								// show toast message
								const { SUCCESS_DELETE_TREATMENT } = this.toastMessages.treatment(treatment.product.name);
								this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_DELETE_TREATMENT);

								// refresh the table
								this.refreshTableContent();

								// refresh notification
                                this.refreshSidebarAndNotif();
							} else {
								const { ERROR_DELETE_TREATMENT } = this.toastMessages.treatment(treatment.product.name);
								this.showAPIErrorToast(ERROR_DELETE_TREATMENT, res);
							}
						})
				}
			});
        },
        displayDate(treatment) {
            let formattedDisplay = treatment.originalApplicationSchedule;
            if (treatment.dateApplied && treatment.dateApplied !== 'Invalid date') {
                formattedDisplay = treatment.dateApplied;
            }
            return format(parseISO(formattedDisplay), 'dd-MMM-yyyy');
        },
        refreshSidebarAndNotif() {
			EventBus.$emit('refreshNotification');
            this.$store.dispatch('setTreatmentOverdueCount', this.getActivePet.id);
		}
    }
}